import { GET } from './api'

export const Read = async () => {
    return await GET(`/fund-and-assets-reports`, true);
}
